export default __webpack_public_path__ + "static/media/envelope.be12debf.svg";